import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useSuppliersApi } from "../../http/suppliers/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteSupplierDialogProps = {
  supplierId: string;
  onClose: () => void;
};

const DeleteSupplierDialog: FC<DeleteSupplierDialogProps> = ({ onClose, supplierId }) => {
  const i18n = useI18n();
  const suppliersApi = useSuppliersApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.suppliers.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            suppliersApi
              .deleteAdminSupplier(supplierId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.suppliers.questions.delete}
    </ModalDialog>
  );
};

export default DeleteSupplierDialog;
